import { computed, unref } from 'vue'
import { createMultipleListQuery } from '../utils'
import { createSharedComposable } from '@vueuse/core'
import { useCountries } from '@/composables/useCountries'
import { useMeta } from '@/composables/useMeta'

export const useCompareRegions = createSharedComposable(() => {
    const { byRegion } = useCountries()
    const { meta } = useMeta()

    const list = computed(() => {
        return unref(meta.regions)?.map(region => ({
            label: region.name,
            value: region.id,
            countries: unref(byRegion).get(region.id) ?? []
        }))
    })

    return createMultipleListQuery('compare-regions', list, {
        normalize: value => value?.map(Number).filter(Boolean),
        set: values => {
            if (!values) return

            return values.join('-')
        },
        defaultValue: []
    })
})
